<template>
  <div class="flex justify-center">
    <div class="m-4 p-6 md:w-1/2">
      <h2 class="text-center">
        <component :is="icon" class="text-bold mx-auto h-20 w-20 text-gray-300" />
      </h2>
      <br />
      <h2 class="text-center text-2xl font-bold text-gray-300">
        {{ msg }}
      </h2>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Empty',
  props: {
    msg: {
      type: String,
      default: 'No se encontraron datos',
    },
    icon: {
      type: String,
      default: 'OutlineInformationCircleIcon',
    },
  },
}
</script>
